import { ROLES, PLANS } from '../../permissions/constants';

const PAYMENTS_PERMISSIONS_IDS = {
  /* payment management features (shared view + Payment
 issues, Refunds, comment */
  paymentsManagement: 'paymentsManagement',
  paymentsInsights: 'paymentsInsights',
};

const PAYMENTS_PERMISSIONS = [
  {
    id: PAYMENTS_PERMISSIONS_IDS.paymentsManagement,
    default: false,
    plans: {
      [PLANS.rise]: {
        default: true,
        roles: {
          [ROLES.developer]: false,
        },
      },
      [PLANS.scale]: {
        default: true,
        roles: {
          [ROLES.developer]: false,
        },
      },
    },
  },
  {
    id: PAYMENTS_PERMISSIONS_IDS.paymentsInsights,
    default: true,
    roles: {
      [ROLES.customerSupport]: false,
    },
  },
];

export { PAYMENTS_PERMISSIONS, PAYMENTS_PERMISSIONS_IDS };
